import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
export const SOURCING_EVENT_TEMPLATES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'SOURCING_EVENT_TEMPLATES'
);
export const SOURCING_EVENT_TEMPLATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SOURCING_EVENT_TEMPLATES_CRUD_ACTION_CONSTANTS
);
